import { render, staticRenderFns } from "./notificationList.vue?vue&type=template&id=1e3d0d34"
import script from "./notificationList.vue?vue&type=script&lang=js"
export * from "./notificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports